import { render, staticRenderFns } from "./VoiceCallView.vue?vue&type=template&id=139bc75b&scoped=true&"
import script from "./VoiceCallView.vue?vue&type=script&lang=js&"
export * from "./VoiceCallView.vue?vue&type=script&lang=js&"
import style0 from "./VoiceCallView.vue?vue&type=style&index=0&id=139bc75b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139bc75b",
  null
  
)

export default component.exports